export const m = {
    about: '關於',
    Qualification: '資格',
    LegalDocument: '法律文件',
    Partners: '夥伴',
    ContactUs: '聯繫我們',
    Trade: '交易',
    IEO: 'IEO',
    OTC: 'OTC',
    News: '新聞',
    Announcement: '公告',
    IndustryNews: '行業新聞',
    Assets: '資產',
    Personalcenter: '個人中心',
    logout: '退出',
    login: '登錄',
    register: '註冊',
    Exchange: '交換',
    LVOSubscribe: '認購',
    Notice: '通知',
    Tradingpair: '交易對',
    Latestprice: '最新價格',
    hChange: '24小時變更',
    hHigh: '24小時最高價',
    hLow: '24小時最低價',
    hVolume: '24小時成交量',
    Deal: '操作',
    gBlockchain: '全球區塊鏈資產交易平台',
    ReliableSystem: '可靠的系統',
    RelGuaranteestem: '保證交易的安全，穩定，高效',
    Elitewor: '世界頂尖人才的精英團隊',
    Safetyfund: '資金安全',
    encryption: 'Https數據加密，身份驗證',
    encryptarchitectureion: '冷錢包存儲，財務級架構，多重安全保護',
    eexperienceon: '最好的體驗',
    eeMultilingualn: '快速提款，多語言',
    Highperformance: '高性能交易引擎，快速交易經驗',
    Professionalservices: '專業的服務',
    Professiinternational: '專業的國際服務團隊',
    problemsal: '及時響應用戶問題',
    Anywhere: '隨時隨地，指尖交易',
    cryptocurrencye: "cornucopia的所有加密貨幣交換的強大功能，都在您的掌中。 立即下載cornucopia移動加密交易應用程序。",
    cryTradingcye: "開始交易",
    Deposi: "存款",
    Help: "幫助",
    Registernow: "現在註冊",
    trading: "開始交易",
    Beginnerguide: "初學者指南",
    FAQ: "常問問題",
    FADigitalQ: "數字資產介紹",
    PrivacyPolicy: "隱私政策",
    Disclaimer: "免責聲明",
    UserAgreement: "用戶協議",
    Mail: "郵件",
    Address: "地址",
    Unitedsta: "美国纽约",
    UniDigitaltedsta: "数字资产是具有高价格波动性和高投资风险的创新型投资产品。在投资之前，请充分认识数字资产，理性判断其投资能力，做出谨慎的投资决策。",
    Risktips: "風險提示",
    COMMITTED: "我們致力於幫助區塊鏈項目籌集資金以尋找支持者，並使新鮮和有趣的想法成為現實。",
    CURRENCY: "新幣火熱發行中",
    CURInformationNCY: "LVO-代幣信息",
    CURInformatiFVG: "FVG-代幣信息",
    CURInformatcvv: "CVV-代幣信息",
    Circulation: "發行總量",
    Liquidity: "流通總量",
    Initialprice: "發行價格",
    Lockcycle: "鎖定週期",
    Deadline: "最後期限",
    DeaSubscrip: "認購倒計時",
    Subscribe: "認購",
    SessionTicket: "LVO-USDT認購正在進行中",
    SOperatingt: "LVO-基於 DApp的操作系統",
    Price: "發行價格",
    SessionSupply: "認購總量",
    Sessipaper: "下載項目白皮書",
    Requirements: "項目參與條件",
    Reqcompleteents: "為符合代幣發售方的要求，所有用戶必須完成帳戶驗證",
    Pleaseents: "請登錄",
    ProjectIntroduction: "項目簡介",
    Keyfeatures: "主要特點",
    Purposeof: "目的",
    TOKENALLOCATION: "代幣分配",
    TOKENSCHEDULE: "代幣發行時間表",
    MyAssets: "我的資產",
    Withdrawhistory: "充提幣記錄",
    SubscribeHistory: "認購記錄",
    Capitalflow: "資金流水",
    Deposit: "充幣",
    TotalAssets: "總資產",
    Toconversionsets: "注意：總資產轉換是根據市場報價估算的，僅為用戶提供參考",
    SmallBalances: "隱藏小額資產幣種",
    Currency: "幣種",
    Total: "總計",
    Available: "可用",
    Frozen: "凍結",
    Description: "操作",
    Withdraw: "提幣",
    WithdrawAddress: "提幣地址",
    WithdrawAmount: "提幣數量",
    ServiceCharge: "服務費用",
    Amountarrival: "到賬數量",
    fundpwd: "資金密碼",
    Tips: "注",
    minimum: "最小提幣數量為",
    musuallyum: "提幣通常需要2-24小時才能完成，到達後會通過電子郵件通知您。為了確保資金安全，當您的帳戶安全策略更改，密碼更改或使用新地址提款時，我們 將進行手動審核。請耐心等待工作人員通過電話或電子郵件聯繫。",
    muconfirmyum: "確保確認計算機和瀏覽器的安全性，以防止信息被篡改或洩漏。",
    forbiddenum: "禁止在Cornucopia平台的帳戶之間充幣和提幣，必要時可以進行轉帳操作。 ",
    DepositAddress: "充幣地址",
    Copy: "複製",
    blockchainCopy: "我已充幣",
    confirmnCopy: "確保確認計算機和瀏覽器的安全性，以防止信息被篡改或洩漏。",
    forbidden: "禁止在Cornucopia平台的帳戶之間充幣和提幣，必要時可以進行轉帳操作。",
    Type: "類型",
    Startt: "開始時間",
    EndTime: "結束時間",
    QUERY: "查詢",
    Amount: "數量",
    Balance: "結餘",
    Time: "時間",
    Status: "狀態",
    Commissions: "綜合服務費",
    Blockchainid: "區塊鏈ID",
    Ins: "品種",
    TotalValue: "Tổng giá trị",
    newcurrency: "新货币订阅",
    Tokeninformation: "令牌信息",
    Day: "天",
    Dsubscriptionay: "您的订阅",
    Pleaseonay: "请输入存折",
    availablebalance: "可用余额",
    All: "所有",
    SUBMIT: "已提交",
    SUWelcomeBMIT: "欢迎回来，请输入您的用户信息",
    Account: "賬戶",
    Password: "密碼",
    ForgetPassword: "忘記密碼",
    notForaccount: "還沒有賬戶",
    Signnow: "立即註冊",
    Welcomejois: "歡迎加入我們",
    Phone: "電話",
    Email: "郵箱",
    Nationality: "國籍",
    LoginPassword: "登錄密碼",
    ConfirmPassword: "確認登錄密碼",
    VerificationCode: "驗證碼",
    InvitationCode: "邀請碼",
    Ihavereae: "我已閱讀",
    Useragreement: "《用戶協議》",
    Existingaccount: "已有賬戶",
    Loginimmediately: "立刻登錄",
    BasicInformation: "基本信息",
    MyAccount: "我的賬戶",
    Nickname: "暱稱",
    Change: "修改",
    UserID: "用戶ID",
    FundPassword: "資金密碼",
    FResetssword: "重置資金密碼",
    Noteoriginal: "注意：重置後，原始的資金密碼將被丟棄，新的密碼將用於交易。",
    DoubleAuthentication: "雙重身份驗證",
    Bind: "綁定",
    Edit: "編輯",
    Verification: "實名認證",
    licensetype: "證件類型",
    name: "姓名",
    licensenumber: "證件號碼",
    PaymentAccount: "收款賬戶",
    Add: "新增",
    Apaymentdd: "您還未設置任何收款賬戶",
    Delete: "删除",
    LoginHistory: "登錄歷史",
    Loginmethod: "登錄方式",
    IP: "IP",
    Riskdisclosurebook: "风险披露书",
    chinaz: "中文繁体",
    LatestNews: "最新新闻",
    updatesnse: "实时更新，第一手资料，第一时间解读",
    Curency: '币种',
    Curplatformency: "全球頂尖的綜合性交易平臺",
    digitalency: "在安全、公平、透明的環境中交易差價合約",
    coinsency: "交易差價合約的最佳場所",
    coIntegrationency: "金融與科技的融合",
    basictionency: "強大的基礎財務和交易基礎設施，採用多層和多集群系統架構，大幅提高系統的安全性、穩定性，AI 技術及微服務拆分設計應用，智能提升交易安全係數",
    bandency: "快速、簡潔的交易平台",
    basystemcy: "兆位記憶匹配系統，準確快速的交易指令執行，核心交易的低延遲",
    eliteemcy: "專業精英團隊",
    capabiqlities: "頂級區塊鏈、金融及 AI 領域踐行者打造專業團隊，具備強大的新業務、個性業務的快速開發能力，提供7*24 小時多語言客服支持",
    fairities: "安全、公平、透明的交易環境",
    regulatoryties: "持有多個國家的金融監管牌照，同時獲得美國財政部數位幣交易許可證書",
    CFDtrading: 'CFD差價合約交易',
    CFDtmajorng: '以相對較低的保證金和費用交易加密貨幣等主要活躍市場和品種',
    ICOransaction: 'ICO幣兌交易',
    Supportmajorng: '支持全球主流加密貨幣的幣兌交易',
    OTCansaction: 'OTC場外交易',
    otcajorng: '支持各國法幣與主流加密貨幣場外兌換',
    Blockchnsaction: 'Blockchain區塊鏈錢包',
    Blockchjorng: '運用區塊鏈去中心化技術，實現對資產的安全管理，便捷流通',
    Beginorng: '立即開始在VMISL交易',
    LetBeginorng: '讓交易省心更放心',
    LOpeninorng: '開立帳戶',
    stableorng: '快速穩定的交易平臺',
    sPlcgGObleorng: 'VMtrade普通投資者的首選',
    sPSimpleeorng: '簡單、快捷、易用的平臺，所有品種觸手可及。VMtrade是一款基於網絡的應用程序，適合PC端或移動端的網頁登入交易。',
    ssuitableng: 'VMtrade適合所有投資者',
    pWerovide: '我們提供可在PC或移動端下載安裝的交易平臺無論您身在何地，都可以通過安裝下載交易平臺進行交易。',
    accountide: '選擇一個帳戶並提交您的申請',
    cardInvest: '通過借記卡或銀行卡轉帳快速安全地注資。',
    Accesswr: '訪問差價合約等交易品種和交易方式。',
    Acinvestmentsswr: '您的投資價值可能上漲，也可能下跌。在保證金交易中，損失有可能超過保證金甚至是大部分本金。高杠杆意味著高風險，您應仔細考慮您的風險承受能力和對杠杆交易的理解程度。',
    Arealizetsswr: '您必須認識到，風險不僅包含交易風險，還包括一些不可抗力因素所造成的風險，比如：網絡中斷，政治動亂、駭客攻擊等。',
    Parklifetsswr: 'VMISL（China Vision Capital（Hong Kong）Limited）受SFC證券及期貨事務監察委員會監管，持牌編號BII154，査詢連結 https://apps.sfc.hk/publicregWeb/searchByName?locale=zh',
    drtwebfetsswr: '本網站可在全球範圍內訪問，網站上所有的資訊僅供參考，並不構成指引性建議，對於任何人依據本網站或網站的資訊採取的作為或不作為所導致的後果，我們不承擔任何責任。',
    webfetsswr: '下載APP 立即交易',
    home: '首頁',


    // 东盛新增
    selectsown: '請選擇您的下載管道', 
    downffgdr: '本地下載',    
    downfsafgdr: '掃碼下載',
    Qualification:'資質',
    licenseTitle:'受SFC證券及期貨事務監察委員會監管',
    licenseNumber:'持牌編號',
    licenseLink:'查詢鏈接',
    homeTheMost:'最受信賴的金融衍生品交易平臺',
    viewCertificate:'查看證書',
    goldTeam:'金牌精英團隊',

}


// WEBPACK FOOTER //
// ./src/common/lang/zhf.js